import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

export const ChartPage = () => {
    const { slug } = useParams();

    return <Navigate to={`/collections/${slug}`} replace />;
};
